import { USE_API_MOCKS } from '../env';
import { RESTClient, RESTClientMock } from '@api/client';
import {
  PaginatedArgs,
  PaginatedResponse,
} from '@dynamika-shared/types/general';
import { throttle } from 'lodash';
import { fetchTeamMemberListMock } from '@api/mocks/team';
import {
  CreateTeamMemberConfig,
  EditTeamMemberConfig,
  TeamMember,
} from '@dynamika-shared/types/teamMember';
import { API_URL } from '@api/apiDictionary';

export type TeamMembersArgs = {
  institution?: string;
  siteCode?: string;
  role?: string;
};

const api = USE_API_MOCKS ? RESTClientMock : RESTClient;

export const fetchInstitutions = throttle(async (clinicalTrialId: string) => {
  return api.get<[]>(API_URL.institutions.replace(':id', clinicalTrialId));
});

export const fetchTeamMemberList = throttle(
  async (clinicalTrialId: string, args?: PaginatedArgs & TeamMembersArgs) => {
    if (USE_API_MOCKS) {
      fetchTeamMemberListMock(args);
    }

    return api.get<PaginatedResponse<TeamMember>>(
      API_URL.teamMembers.replace(':id', clinicalTrialId),
      {
        params: {
          ...args,
          page: args?.page ? args?.page - 1 : 0,
          size: args?.size ?? 10,
        },
      }
    );
  },
  500
);

export const fetchTeamMemberListAll = async (
  clinicalTrialId: string,
  role?: TeamMembersArgs['role']
) => {
  if (USE_API_MOCKS) {
    fetchTeamMemberListMock();
  }

  return api.get<TeamMember[]>(
    API_URL.teamMembersAll.replace(':id', clinicalTrialId),
    {
      params: {
        ...(role && { role }),
      },
    }
  );
};
export const addTeamMember = async (
  clinicalTrialId: string,
  body: CreateTeamMemberConfig
) => {
  return api.post<CreateTeamMemberConfig>(
    API_URL.teamMembers.replace(':id', clinicalTrialId),
    body
  );
};
export const editTeamMember = async (
  clinicalTrialId: string,
  body: EditTeamMemberConfig
) => {
  return api.put<EditTeamMemberConfig>(
    API_URL.teamMemberUserId
      .replace(':id', clinicalTrialId)
      .replace(':userId', body.userId),
    body
  );
};

export const deleteTeamMember = async (
  clinicalTrialId: string,
  memberId: string
) => {
  return api.delete(
    `${API_URL.teamMembers.replace(':id', clinicalTrialId)}/${memberId}`
  );
};
